module.exports = __webpack_public_path__ + "static/img/RE3.54b176e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE3.jpg
// module id = 2dKV
// module chunks = 0